import { ROUTE, axiosInstance } from '@/core/api/axiosInstance';

import type { AssetGsiItem } from '@/app/api/incidents/asset-gsi.types';
import type { RegionGsiItem, RegionGsiTrendItem } from '@/app/api/incidents/region-gsi.types';
import type { IncidentsColorScheme } from '@/generated/prisma';
import type { IncidentsDateTimeRange } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';

export const incidents = {
  getColorScheme: async (orgId: string) => {
    const { data } = await axiosInstance.get<{ colors: IncidentsColorScheme }>(ROUTE.INCIDENTS.COLOR_SCHEME, {
      params: { orgId },
    });
    return data.colors || {};
  },
  getIncidentsDateTimeRange: async () => {
    const { data } = await axiosInstance.get<IncidentsDateTimeRange>(ROUTE.INCIDENTS.DATE_TIME_RANGE);
    return data;
  },
  getAssetGsi: async ({
    location,
    latitude,
    longitude,
  }: { location?: string; latitude?: number; longitude?: number } = {}) => {
    const { data } = await axiosInstance.get<AssetGsiItem[]>(ROUTE.INCIDENTS.ASSET_GSI, {
      params: { location, latitude, longitude },
    });
    return data;
  },
  getRegionGsi: async ({ dateFrom, dateTo }: { dateFrom?: string | null; dateTo?: string | null } = {}) => {
    const { data } = await axiosInstance.get<RegionGsiItem[]>(ROUTE.INCIDENTS.REGION_GSI, {
      params: { dateFrom: dateFrom ?? undefined, dateTo: dateTo ?? undefined },
    });
    return data;
  },
  getRegionGsiTrend: async ({ months }: { months: number }) => {
    const { data } = await axiosInstance.get<RegionGsiTrendItem[]>(ROUTE.INCIDENTS.REGION_GSI_TREND, {
      params: { months },
    });
    return data;
  },
};
